import { Model } from '@vuex-orm/core';
import { Country, SubLocation, Region } from './models';
import { uuidv4 } from '../../utils/helpers';

export class Location extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'locations';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      name: this.attr(null),
      region_id: this.attr(null),
      region: this.belongsTo(Region, 'region_id'),
      address: this.attr(null),
      city: this.attr(null),
      postal_code: this.attr(null),
      country_code: this.attr(null),
      country: this.belongsTo(Country, 'country_code', 'code'),
      sub_locations: this.hasMany(SubLocation, 'parent_location_id'),
      updated_at: this.attr(null),
      created_at: this.attr(null),
      type: this.attr(null),
    };
  }
}

export default Location;
